// src/index.js
import './styles.css';
import { games } from './games.js';
import { ARButton } from 'three/examples/jsm/webxr/ARButton.js';
import Leaderboard from './core/Leaderboard.js';
import PlayerIdentity from './core/PlayerIdentity.js';

const appContainer = document.getElementById('app-container');
let currentGameInstance = null;
let currentLeaderboard = null;
let arButton = null;

function clearContainer() {
    appContainer.classList.remove('leaderboard-active');
    if (currentGameInstance && typeof currentGameInstance.dispose === 'function') {
        currentGameInstance.dispose();
        console.log('Clearing container ' +currentGameInstance);

    }
    currentGameInstance = null;
    if (currentLeaderboard) {
        currentLeaderboard.hide();
        currentLeaderboard = null;
    }
    if (arButton && arButton.parentNode) {
        arButton.parentNode.removeChild(arButton);
    }
    arButton = null;
    appContainer.innerHTML = '';
}

function renderGameList() {
    clearContainer();
    appContainer.classList.remove('game-detail-view');
    appContainer.innerHTML = `
        <div class="game-list">
            ${games
                .map(
                    (game) => `
                <div class="game-item">
                    <a href="#/play/${game.id}">
                        <img src="${game.image}" alt="${game.name}" class="game-item-image">
                        <h2 class="game-item-title">${game.name}</h2>
                        <p class="game-item-description">${game.description}</p>
                    </a>
                </div>
            `
                )
                .join('')}
        </div>
    `;
}

function renderGameDetail(gameId) {
    clearContainer();
    appContainer.classList.add('game-detail-view');
    appContainer.classList.add('leaderboard-active');
    const gameData = games.find((g) => g.id === gameId);
    if (!gameData) {
        renderGameList(); // Fallback to game list if ID is invalid
        return;
    }

    appContainer.innerHTML = `

        <div class="game-play-layout">
            <div id="game-container">
                <div id="ui-2d">
                    <div class="hud-2d-container">
                        <div id="timer-2d" class="hud-item-2d" style="display: none;">Time: 60</div>
                        <div id="score-2d" class="hud-item-2d" style="display: none;">Score: 0</div>
                        <div id="combo-2d" class="hud-item-2d" style="display: none;">Combo: 0</div>
                        <div id="coins-2d" class="hud-item-2d" style="display: none;">Coins: 0</div>
                        <div id="lives-2d" class="hud-item-2d" style="display: none;">Lives: 3</div>
                        <div id="distance-2d" class="hud-item-2d" style="display: none;">Meters: 0</div>
                        <div id="game-state-2d" class="hud-item-2d" style="display: none;">State: MENU</div>

                    </div>
                    <button id="start-btn-2d" class="ui-element">Start Game</button>
                    <button id="restart-btn-2d" class="ui-element" style="display: none;">Restart</button>
                    <div id="sound-controls-2d">
                    <button id="sfx-mute-btn-2d" class="ui-element sound-btn">
                    <img id="sfx-icon-2d" src="assets/icons/sfx_on.png" alt="Mute Volume">
                    </button>
                    </div>
                    <!-- <button id="music-mute-btn-2d" class="ui-element sound-btn">
                        <img id="music-icon-2d" src="assets/icons/music_on.png" alt="Mute Music">
                    </button> -->
                </div>
            </div>
            <aside id="leaderboard-slot" aria-live="polite"></aside>
        </div>
        
    `;

    const gameContainer = document.getElementById('game-container');
    const ui2d = document.getElementById('ui-2d');

    // Create leaderboard for this game
    currentLeaderboard = new Leaderboard(gameData.id);
    currentLeaderboard.mount();

    currentGameInstance = new gameData.gameClass({
        gameContainer,
        ui2d,
        leaderboard: currentLeaderboard,
    });

    // Setup AR button
    arButton = ARButton.createButton(currentGameInstance.renderer, {
        requiredFeatures: ['local-floor'],
        optionalFeatures: ['hand-tracking'],
    });
    gameContainer.appendChild(arButton);

    // Session listeners
    currentGameInstance.renderer.xr.addEventListener('sessionstart', () => {
        if (typeof currentGameInstance.onEnterXR === 'function') {
            currentGameInstance.onEnterXR();
        }
    });

    currentGameInstance.renderer.xr.addEventListener('sessionend', () => {
        if (typeof currentGameInstance.onExitXR === 'function') {
            currentGameInstance.onExitXR();
        }
    });
}

async function router() {
    const hash = window.location.hash;
    if (hash.startsWith('#/play/')) {
        // Prompt for name before first game
        if (!PlayerIdentity.hasName()) {
            await PlayerIdentity.prompt();
        }
        const gameId = hash.substring('#/play/'.length);
        renderGameDetail(gameId);
    } else {
        renderGameList();
    }
}

// Listen for hash changes to navigate
window.addEventListener('hashchange', router);

// Initial route
if (window.location.hash === '') {
    window.location.hash = '#/games';
} else {
    router();
}
